import React, { Component } from 'react';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import DatePicker from 'react-datepicker';
import ReactTable from "react-table";
import moment from 'moment';
import JSAlert from 'js-alert';
import './App.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-notifications/lib/notifications.css';
import 'react-table/react-table.css'
import './font-awesome/css/font-awesome.min.css'
import Login from './login';
import Dropzone from 'react-dropzone'
import ReactExport from "react-data-export";
import { unregister } from './registerServiceWorker';
unregister();
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const initialShipment = { 
	region : '',
	dimensions : [],
	comments : [],
	po_num : '',
	nl_ref : '',
	cts_ref:'',
	goods_description:'',
	supplier_name:'',
	consignee_name:'',
	new_comment_text : '',
	new_comment_date : '',
	pickup_street:'',
	pickup_city:'',
	pickup_country:'',
	pickup_zip:'',
	delivery_street:'',
	delivery_city:'',
	delivery_country:'',
	delivery_zip:'',
	special_instructions:'',
	status:'',
	danger_goods:'',
	total_weight : 0,
	pieces : 0,
	files : [],
	filesnames: [],
	notice_emails : '',
	pickup_contact:'',
	delivery_contact:'',
	delivery_opening_hours:'',
	pickup_opening_hours:''
};
 class App extends Component {
  constructor(props) {
    super(props);
    // This binding is necessary to make `this` work in the callback
    this.buch = this.buch.bind(this);
    this.buchDva = this.buchDva.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateTable = this.updateTable.bind(this);
    this.openDetail = this.openDetail.bind(this);
    this.performSearch = this.performSearch.bind(this);
    this.updateRecord = this.updateRecord.bind(this);
    this.createRecord = this.createRecord.bind(this);
    this.addDimensionsRow = this.addDimensionsRow.bind(this);
    this.delDimensionsRow = this.delDimensionsRow.bind(this);
    this.shipmentHandleChange = this.shipmentHandleChange.bind(this);
    this.searchFormHandleChange = this.searchFormHandleChange.bind(this);
    this.updateDimensionRow = this.updateDimensionRow.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.showMenu=this.showMenu.bind(this);
    this.loginSuccess = this.loginSuccess.bind(this);
    this.signout = this.signout.bind(this);
    this.printShipment=this.printShipment.bind(this);
	this.handleFileUpload=this.handleFileUpload.bind(this);
	this.downloadFile = this.downloadFile.bind(this);
	this.resetSearch = this.resetSearch.bind(this);
	this.deleteAttachment=this.deleteAttachment.bind(this);
	this.deleteRecord=this.deleteRecord.bind(this);
	this.saveSettings = this.saveSettings.bind(this);
	this.addToAddressBook=this.addToAddressBook.bind(this);
	this.openAddressBook = this.openAddressBook.bind(this);
	this.editAddress = this.editAddress.bind(this);
	this.insertAddress = this.insertAddress.bind(this);
	this.deleteAddress = this.deleteAddress.bind(this);
	this.tableNeedsRefresh = false;
	this.insertElement = "";
	this.emailsAddr = {}

this.initialsearchForm = {
	po_num : '',
	nl_ref: '',
	supplier_name:'',
	consignee_name:'',
	actual_pickup_from:'',
	actual_pickup_to:'',
	created_from :'',
	created_to:'',
	status: '',
	cts_ref:''
};
    this.state = {
		mainContainer : "col-12",
		detailContainer : "d-none",
		settingsContainer : "d-none",
		AddressbookContainer : "d-none",
		date : null,
		tableData : [],
		addressBookData : [],
		shipment : {
			dimensions : [],
			comments : [],
			files:[],
			filesnames : []	
		},
		changed_items : [],
		searchForm : {...this.initialsearchForm},
		isNewRecord : true,
		isEditRecord : false,
		shipment_selected_packing : 'Pallet',
		user : { name : "Petr", role : "Admin" },
		userLoged:false,
		userSignout:false,
		menu_collapse : "collapse"
    }
  }
  loginSuccess = (val) => {
    this.setState({
		user : { name : val.name , role : val.role, canCreateRecord : val.canCreateRecord === "t"? true : false },
		userLoged : true,
		userSignout : false,
    })
    console.log(val);
    this.emailsAddr = JSON.parse(val.config);
    this.performSearch();
    if(window.location.hash.indexOf("#")!==-1){
    	var q = window.location.hash.split("&");
    	if(Number.isInteger(Number(q[0].substr(1)))){
			this.openDetail(window.location.hash.substr(1));
				window.location.hash="";
		}
    }
}	
	signout(){

	fetch("https://demo-rcm.mauriceward.com/api.php?action=signout" , {   
		method: 'GET',
		credentials: 'include'
  		 }).then( 		
  		 	this.setState({
			user : {},
			userSignout : true,
			userLoged : false    
   	}) ).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });	
	}
	
addToAddressBook(e){
	var self = this;
	var a = e;
	var b = "pickup";
	if (a==="consignee")b="delivery";
	var t = "<table><tr><td>Name:</td><th>"+this.state.shipment[a+"_name"]+"</th></tr>"+
	"<tr><td>Street:</td><th>"+this.state.shipment[b+"_street"]+"</th></tr>"+
	"<tr><td>City:</td><th>"+this.state.shipment[b+"_city"]+"</th></tr>"+
	"<tr><td>Country:</td><th>"+this.state.shipment[b+"_country"]+"</th></tr>"+
	"<tr><td>Post code:</td><th>"+this.state.shipment[b+"_zip"]+"</th></tr>"+
	"<tr><td>Contact:</td><th>"+this.state.shipment[b+"_contact"]+"</th></tr>"+
	"<tr><td>Opening hours:</td><th>"+this.state.shipment[b+"_opening_hours"]+"</th></tr>"+
	"</table>";
JSAlert.confirm("Are you sure you want to add following to address book ?"+t).then(function (result) {
	if (!result)return;
		var o = {
		action : "addtoaddressbook",	
		name : self.state.shipment[a+"_name"],
		street : self.state.shipment[b+"_street"],
		city: self.state.shipment[b+"_city"],
		country : self.state.shipment[b+"_country"],
		zip : self.state.shipment[b+"_zip"],
		contact : self.state.shipment[b+"_contact"],
		opening_hours : self.state.shipment[b+"_opening_hours"]
		}	
	 fetch("https://demo-rcm.mauriceward.com/api.php?data", {   
	 method: 'POST',
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',
		body : JSON.stringify(o),
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        	self.createNotification(res.status,res.message) 
				if (res.status==="success") {

					
				}
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
	})
}
editAddress(props) {
	var self = this;
var t = "<form id='editaddressForm' style='min-width:500px;'><input type='hidden' name='recnum' value='"+props.recnum+"'><table style='width:100%' class='table-striped'><tr><tr><td>Name</td><td><input class='form-control' name='name' value='"+props.name+"'</td></tr>";
t+="<tr><td>Street</td><td><input name='street' class='form-control' value='"+props.street+"'</td></tr>";
t+="<tr><td>City</td><td><input name='city' class='form-control' value='"+props.city+"'</td></tr>";
t+="<tr><td>Country</td><td><input name='country' class='form-control' value='"+props.country+"'</td></tr>";
t+="<tr><td>Post Code</td><td><input name='zip' class='form-control' value='"+props.zip+"'</td></tr>";
t+="<tr><td>Contact person</td><td><input name='contact' class='form-control' value='"+props.contact+"'</td></tr>";
t+="<tr><td>Opening hours</td><td><input name='opening_hours' class='form-control' value='"+props.opening_hours+"'</td></tr></form></table>";
var alert = new JSAlert(t,"Edit Address");
alert.addButton("Cancel").then(function() {
    return;
});
alert.addButton("Save").then(function() {
    var f = document.getElementById("editaddressForm");
		var o = {
		action : "editaddressbook",	
		recnum : f.recnum.value,
		name : f.name.value,
		street : f.street.value,
		city: f.city.value,
		country : f.country.value,
		zip : f.zip.value,
		contact : f.contact.value,
		opening_hours : f.opening_hours.value
		}
		console.log(o);
			
	 fetch("https://demo-rcm.mauriceward.com/api.php?data", {   
	 method: 'POST',
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',
		body : JSON.stringify(o),
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        	self.createNotification(res.status,res.message) 
				if (res.status==="success") {
					var data = self.state.addressBookData;
					console.log(data)
					data.forEach(function (e,i) {
						if (e.recnum===o.recnum) {
							data[i]=o;
						}
					})
					self.setState({addressBookData :data});
				}
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
});
alert.show();
}
openAddressBook(e){
	this.insertElement = e;
this.setState({ AddressbookContainer : "col-12", detailContainer : "d-none" }); 
		var al = JSAlert.loader("<i class='fa fa-spinner fa-pulse fa-3x fa-fw'></i><br>Please wait...")
		fetch("https://demo-rcm.mauriceward.com/api.php?addressbook", {   
		method: 'GET',
		credentials: 'include',
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        		al.dismiss()
				this.setState({ addressBookData : res } )
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
}
insertAddress(e){
	if (this.state.isNewRecord!==true){
		this.createNotification("info","Changes to existing records are not allowed..");
		return	
	}
	var a = "pickup";
	if (this.insertElement==="consignee")a="delivery";
	var o = {};
	o[this.insertElement+"_name"]=e.name;
	o[a+"_street"]=e.street;
	o[a+"_city"]=e.city;
	o[a+"_country"]=e.country;
	o[a+"_zip"]=e.zip;
	o[a+"_contact"]=e.contact;
	o[a+"_opening_hours"]=e.opening_hours;	
this.setState({ shipment : { ...this.state.shipment,...o},detailContainer : "col-12",AddressbookContainer : "d-none" });
window.setTimeout(()=>{ window.document.getElementById(this.insertElement).scrollIntoView() },10);
}
deleteAddress(e){ 
	var self = this;
JSAlert.confirm("Are you sure you want to delete this row from address book?",null, JSAlert.Icons.Deleted).then(function(result) {
    if (!result)
        return;
		fetch("https://demo-rcm.mauriceward.com/api.php?deleteaddress="+e, {   
		method: 'GET',
		credentials: 'include',
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        	self.createNotification(res.status,res.message)
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
    })	
}
downloadFile(num){
	window.open("https://demo-rcm.mauriceward.com/api.php?downloadRecnum="+num+"&stamp"+new Date().toUTCString() );
}
deleteAttachment(num,clientside){
	var self= this;
	if (clientside===true) {
		var a = [];
		Object.assign(a,this.state.shipment.files);
		a = a.filter(e=> e.name!==num);
		self.setState({ shipment : { ...self.state.shipment, files : a }});
		return;
	}
	
JSAlert.confirm("Are you sure you want to delete this file?<br>This action has an immediate effect, no way to roll back...",null, JSAlert.Icons.Deleted).then(function(result) {
    if (!result)
        return;
      var o = {
			action:'deletefile',
			file:num,
			fromshipment:self.state.shipment.recnum      
      }
		fetch("https://demo-rcm.mauriceward.com/api.php?data", {   
	 method: 'POST',
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',
		body : JSON.stringify(o),
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        	self.createNotification(res.status,res.message) 
				if (res.status==="success") {
					var files = self.state.shipment.filesnames;
					files = files.filter(function(item) { 
   				 return item[0] !== num
					})
					self.setState({ shipment : {...self.state.shipment,filesnames:files } })
				}
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
	})
}
   createNotification(type,message) {

      switch (type) {
        case 'info':
          NotificationManager.info(message);
          break;
        case 'success':
          NotificationManager.success(message);
          break;
        case 'warning':
          NotificationManager.warning(message);
          break;
        case 'error':
          NotificationManager.error(message, '', 0);
          break;
      }

  };
  printShipment(t){
  	/*
  			fetch("https://demo-rcm.mauriceward.com/api.php?printRecnum=52", {   
	 method: 'GET',
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',
  		 })
		 .then((response) => console.log(response));
		 */
	if(t==="p")window.open("https://demo-rcm.mauriceward.com/api.php?printRecnum="+this.state.shipment.recnum+"&stamp"+new Date().toUTCString());
	if(t==="c")window.open("https://demo-rcm.mauriceward.com/api.php?printDelivery="+this.state.shipment.recnum+"&stamp"+new Date().toUTCString());
//	this.setState({ output_ref : "https://demo-rcm.mauriceward.com/api.php?printRecnum="+this.state.shipment.recnum+"&stamp"+new Date().toUTCString() });
  } 
	buch(what) {	
		if (what==="new") {
		this.setState({
			shipment : {...initialShipment},
			isNewRecord : true,
			isEditRecord : false,
			changed_items : [],
		mainContainer : "d-none",
		detailContainer : "col-12",
		settingsContainer :"d-none",
		AddressbookContainer : 'd-none'
		})
		window.scrollTo(0,56)		
		}else if (what==="settings") {
		this.setState({
			mainContainer : "d-none",
			detailContainer : "d-none",
			settingsContainer : "col-12",
			AddressbookContainer : 'd-none'
		})
		}	else {
			this.setState({
			isNewRecord : false,
			isEditRecord : true,
			mainContainer : "d-none",
			detailContainer : "col-12",
			settingsContainer :"d-none",
			AddressbookContainer : 'd-none'
		});
		window.scrollTo(0,56);
		}	
	}
	buchDva(e) {
		if (this.tableNeedsRefresh ===true){
			this.performSearch();
			this.tableNeedsRefresh = false;		
		}
		this.setState({
		mainContainer : "col-12",
		detailContainer : "d-none",
		})
		window.scrollTo(0,56);
	}	
	handleChange(date){
		this.setState({
			date:date
		})	
	}
	saveSettings(e){
		e.preventDefault();
		var data = new FormData(e.target);
		var o = { 
			"action":"savesettings",
			"config": {
				"EU Collection" : data.get("EU Collection"),
				"Non EU Collection" : data.get("Non EU Collection"),
				"Domestic Collection" : data.get("Domestic Collection")
			}
		}
	fetch("https://demo-rcm.mauriceward.com/api.php?data" , {   
	 method: 'POST',
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',

		body : JSON.stringify(o),
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
				this.createNotification(res.status,res.message);
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
	}
shipmentHandleChange(e){
		var value = e.target.value;
		var name = e.target.name;
		if(this.state.user.role !== "admin"&&this.state.isNewRecord===false){
			this.createNotification("info","You are not allowed to change this field.");
			return;		
		}
		var shipment = {...this.state.shipment};
		var changeditems = this.state.changed_items;
		switch(name) {
			case "ready_date":
				shipment.status="Booking Received";
				this.createNotification("info","Status is set to Booking Received");
				if(changeditems.indexOf("status") < 0)changeditems.push("status");
			break;
			case "actual_pickup":
				shipment.status="Collected";
				this.createNotification("info","Status is set to Collected"); 
				if(changeditems.indexOf("status") < 0)changeditems.push("status");
			break;
			case "actual_arrival":
				shipment.status="Arrived";
				this.createNotification("info","Status is set to Arrived"); 
				if(changeditems.indexOf("status") < 0)changeditems.push("status");
			break;
			case "loaded_date":
				shipment.status="Loaded on trailer";
				this.createNotification("info","Status is set to Loaded on trailer"); 
				if(changeditems.indexOf("status") < 0)changeditems.push("status");
			break;
			case "off_loaded":
				shipment.status="Off loaded";
				this.createNotification("info","Status is set to Off loaded"); 
				if(changeditems.indexOf("status") < 0)changeditems.push("status");
			break;
			case "region":
				shipment.notice_emails = this.emailsAddr[value];
			break;
		}
		shipment[name]=value;
		if(changeditems.indexOf(name) < 0){
			changeditems.push(name)
			this.setState( { changed_items : changeditems } ) 
		}
		this.setState( { shipment : shipment } )			
	} 
searchFormHandleChange(e){
		var value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
		var name = e.target.name; 
		var searchForm = {...this.state.searchForm};
		if (name==="created_to"|| name==="actual_pickup_to") {
			value = moment(value).hours(23).minutes(59);	
		}
		if (name==="status"&&value==="Off loaded")searchForm["include_off"]=true;
		searchForm[name]=value;
		this.setState( { searchForm : searchForm } )				
	} 	
resetSearch(){
	this.setState({ searchForm : {...this.initialsearchForm} })
}	
	
handleFileUpload( files ) {
	var self = this;
//	files = files.target.files;
	var count = files.length;
    if (files.length>0) {
    	var a = [];
    	Object.assign( a,this.state.shipment.files);
    	for(var i=0;i<count;i++){
         // create reader
        var reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = (function(file) {
        	
        var filename = file.name;
        var mimetype = file.type;        	
        var ext = filename.split(".").pop();
        return function (e) {
        	console.log(e);
        var contents = e.target.result.split("base64,").pop();
			a.push({name:filename, mimetype: mimetype, source: contents, ext: ext });
			count--;
			if (count===0) {
				self.setState({ shipment : { ...self.state.shipment, files : a }});
				self.createNotification("info","Files are ready to upload" );
			}
        }})(files[i]);   		
    		}
    }	
   
	
}
	updateTable(recnum){
		var tableData = this.state.tableData;
		var index = tableData.findIndex(e => e.recnum === recnum);
		tableData[index]=this.state.shipment;
		this.setState({tableData : tableData })	
	}
	updateRecord(){
		var data = this.state.shipment;
		data.action = "update";	
		data.changeditems = this.state.changed_items;
		this.saveRecord(data)
	}
	createRecord(){
		var data = this.state.shipment;
		this.tableNeedsRefresh = true;
		data.action = "insert";
		var requiredFields = ["region","total_weight","pieces","supplier_name","pickup_street","pickup_city","pickup_country","pickup_zip","files"];
		var a = true;
		requiredFields.forEach(e=>{
			if (data[e]===""||data[e]===0){ 
				this.createNotification('warning',e+ " field is required");
				a=false;
			}
		})		
		if(data.dimensions.length===0){
			this.createNotification('warning',"Please enter cargo dimensions");
			a = false;
		}
		if(a)this.saveRecord(data)	
	}
	saveRecord(data){
		var myHeaders = new Headers();
		var self = this;
myHeaders.append('Content-Type', 'application/json');

	fetch("https://demo-rcm.mauriceward.com/api.php?data" , {   
	 method: 'POST',
    headers: myHeaders,
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',

		body : JSON.stringify(data),
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
				this.createNotification(res.status,res.message);
				if (res.status==="success") {
					this.setState({isNewRecord:false,isEditRecord : true,changed_items:[] });
					this.openDetail(res.recnum)
					this.updateTable(res.recnum);
				}
        		if (res.status==="error"){ 
        			if (res.message==="Please login") {
        				JSAlert.alert("Session closed, please sign in again",null,JSAlert.Icons.Failed).then(()=>
        				 self.setState({
							user : {},
							userSignout : true,
							userLoged : false    
				   	}) 
				   	)
        			}
        			else JSAlert.alert(res.message,null,JSAlert.Icons.Failed);
        			return;
        		}
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
	}
	deleteRecord(num){
		var self = this;
		JSAlert.confirm("Are you sure you want to delete this record and all attached files ?<br>This action has an immediate effect, no way to roll back...",null, JSAlert.Icons.Deleted).then(function(result) {
    if (!result)
        return;
      var o = {
			action:'deleterecord',
			shipment: num     
      }   
	fetch("https://demo-rcm.mauriceward.com/api.php?data" , {   
	 method: 'POST',
    mode: 'cors',
    cache: 'default',
	 credentials : 'include',

		body : JSON.stringify(o),
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
				self.createNotification(res.status,res.message);
				if (res.status==="success") {
					self.tableNeedsRefresh=true;
					self.buchDva();
				}
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });      
     })
	}
	addDimensionsRow(){
		if(this.state.user.role !== "admin"&&this.state.isNewRecord===false){
			this.createNotification("info","You are not allowed to change this field.");
			return;		
		}
		this.setState( prevState =>({
			shipment : {
				...prevState.shipment,
				dimensions: [...prevState.shipment.dimensions,{ rowId : prevState.shipment.dimensions.length,packing : this.state.shipment_selected_packing,width:'',height:'',pieces:'',weight:'' } ]			
			}		
		}) )	
	}
	delDimensionsRow(rowId){
		if(this.state.user.role !== "admin"&&this.state.isNewRecord===false){
			this.createNotification("info","You are not allowed to change this field.");
			return;		
		}
		var counter = 0;
		var rows = this.state.shipment.dimensions.filter((e)=>{
			if(e.rowId !== rowId){
				e.rowId = counter;
				counter++;
				return e;			
			}
		})
		this.setState( prevState =>({
			shipment : {
				...prevState.shipment,
				dimensions: rows			
			}		
		}) )			 
	}
	showMenu(){
		var collapse ="collapse";
		if (this.state.menu_collapse==="collapse") {
			collapse = "";
		}
		this.setState({menu_collapse : collapse })	
	}
	updateDimensionRow(e,rowId){
		if(this.state.user.role !== "admin"&&this.state.isNewRecord===false){
			this.createNotification("info","You are not allowed to change this field.");
			return;		
		}
		var total_weight = 0; 
		var pieces = 0;
		var rows = this.state.shipment.dimensions.filter((row)=>{
			if(row.rowId === rowId){
				row[e.target.name]= e.target.value;
				total_weight+= Number(row.weight) * Number(row.pieces);
				pieces += Number(row.pieces);
				return row;			
			}
			else {
				total_weight+=Number(row.weight) * Number(row.pieces);
				pieces += Number(row.pieces);
				return row;
			}
		})		
		this.setState( prevState =>({
			shipment : {
				...prevState.shipment,
				dimensions: rows,
				total_weight : total_weight,
				pieces:pieces		
			}		
		}) )	
	}
	openDetail(id){
		var self=this;
		fetch("https://demo-rcm.mauriceward.com/api.php?recnum="+id, {   
		method: 'GET',
		credentials: 'include'
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        		if (res.status==="error"){ 
        			if (res.message==="Please login") {
        				JSAlert.alert("Session closed, please sign in again",null,JSAlert.Icons.Failed).then(()=>
        				 self.setState({
							user : {},
							userSignout : true,
							userLoged : false    
				   	}) 
				   	)
        			}
        			else JSAlert.alert(res.message,null,JSAlert.Icons.Failed);
        			return;
        		}
        		var shipment = res;
        		if (shipment===false) {
        			JSAlert.alert("Unable to open shipment, record doesn't exist.",null,JSAlert.Icons.Failed)
        			return false;
        		}
        		shipment.created = moment(shipment.created);
        		if(shipment.dimensions===null)shipment.dimensions = [];
        			else shipment.dimensions = JSON.parse(shipment.dimensions);
        		if(shipment.comments===null)shipment.comments = [];
        			else shipment.comments = JSON.parse(shipment.comments);
        		if(shipment.booking_date!==null)shipment.booking_date=moment.utc(shipment.booking_date);
        		if(shipment.ready_date!==null)shipment.ready_date=moment.utc(shipment.ready_date);
        		if(shipment.est_pickup!==null)shipment.est_pickup=moment.utc(shipment.est_pickup);
        		if(shipment.actual_pickup!==null)shipment.actual_pickup=moment.utc(shipment.actual_pickup);
        		if(shipment.eta!==null)shipment.eta=moment.utc(shipment.eta);
        		if(shipment.actual_arrival!==null)shipment.actual_arrival=moment.utc(shipment.actual_arrival);
        		if(shipment.loaded_date!==null)shipment.loaded_date=moment.utc(shipment.loaded_date);
        		if(shipment.off_loaded!==null)shipment.off_loaded=moment.utc(shipment.off_loaded)
				shipment.filesnames = JSON.parse(shipment.filesnames);
				this.setState({ shipment : { ...initialShipment, ...shipment },changed_items : []});
				this.buch();
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });
	}
	performSearch(){
		var al = JSAlert.loader("<i class='fa fa-spinner fa-pulse fa-3x fa-fw'></i><br>Please wait...");
		var self = this;
		fetch("https://demo-rcm.mauriceward.com/api.php?search&data="+JSON.stringify(this.state.searchForm), {   
		method: 'GET',
		credentials: 'include',
  		 })
		 .then((response) => response.json())
		 .then(
        (res) => {
        		al.dismiss()
        		if (res.status==="error"){ 
        			if (res.message==="Please login") {
        				JSAlert.alert("Session closed, please sign in again",null,JSAlert.Icons.Failed).then(()=>
        				 self.setState({
							user : {},
							userSignout : true,
							userLoged : false    
				   	}) 
				   	)
        			}
        			else JSAlert.alert(res.message,null,JSAlert.Icons.Failed);
        			return;
        		}
				this.setState({ tableData : res } )
        }).catch((error) => {
         	if(error)JSAlert.alert(error,null,JSAlert.Icons.Failed)
        });	
	}
  render() {
  const columns = [{
    Header: '',
    accessor: 'recnum',
    width: 70,
    Cell : props => <button className="btn btn-primary btn-sm" onClick={ () => this.openDetail(props.value) } id={props.value}>Open</button>

  },
  {
    Header: 'MW Reference',
    accessor: 'cts_ref' // String-based value accessors!
  },
  {
    Header: 'BOL Number',
    accessor: 'po_num' // String-based value accessors!
  }
  , {
    Header: 'Asset Number',
    accessor: 'nl_ref',
   // Cell: props => <span className='number'>{props.value}</span> // Custom cell components!

  }
  ,{
    Header: 'Supplier',
    accessor: 'supplier_name' // String-based value accessors!
  },
  {
    Header: 'Consignee',
    accessor: 'consignee_name' // String-based value accessors!
  },
  {
    Header: 'City/Town',
    accessor: 'delivery_city' // String-based value accessors!
  }
	,{
    Header: 'Country',
    accessor: 'delivery_country' // String-based value accessors!
  }
  ,{
    Header: 'Pieces',
    width : 80,
    accessor: 'pieces' // String-based value accessors!
  } 
  ,{
    Header: 'Goods description',
    accessor: 'goods_description' // String-based value accessors!
  } 
,{
    Header: 'Weight',
    accessor: 'total_weight', // String-based value accessors!
  }
,{
    Header: 'ETD',
    accessor: 'est_pickup', // String-based value accessors!
    Cell : props =>  props.value ? moment(props.value).format("DD.MM.YYYY") : null
  }
,{
    Header: 'ETA',
    accessor: 'eta',
    Cell: props => props.value ? moment(props.value).format("DD.MM.YYYY") : null
  } 
  ,{
    Header: 'Created',
    accessor: 'created', // String-based value accessors!
    Cell : props => moment(props.value).format("DD.MM.YYYY H:m")
  }
  ,{
    Header: 'Status',
    accessor: 'status', // String-based value accessors!
    width: 260,
	 Cell: props => ( 
	 	props.value==="Collected" ? props.value + ' - ' + moment(props.row._original.actual_pickup).format("DD.MM.YYYY") : (
			props.value==="Booking Received" ? props.value + ' - ' + moment(props.row._original.booking_date).format("DD.MM.YYYY") : (
				props.value==="Arrived" ? props.value + ' - ' + moment(props.row._original.actual_arrival).format("DD.MM.YYYY") : (
					props.value==="Loaded on trailer" ? props.value + ' - ' + moment(props.row._original.loaded_date).format("DD.MM.YYYY") : (
						props.value==="Off loaded" ? props.value + ' - ' + moment(props.row._original.off_loaded).format("DD.MM.YYYY") : null
					)	 	
			 	)	 	
	 		)	 	
	 	)
	  )
  }];
   const addressBookColumns = [
 {
    Header: '',
    accessor: 'recnum',
    width: 130,
    Cell : props => (
    	<div className="btn-group">
    	<button className="btn btn-success" title="Select" onClick={ () => this.insertAddress(props.row) } ><i className="fa fa-check"/></button>
    	<button className="btn btn-danger" title="Delete" onClick={ () => this.deleteAddress(props.value) } ><i className="fa fa-trash"/></button>
    	<button className="btn btn-default" title="Edit" onClick={ () => this.editAddress(props.row) } ><i className="fa fa-pencil"/></button>
    	</div>)

  },
    {
    Header: 'Name',
    accessor: 'name'
  },
{
    Header: 'Street',
    accessor: 'street'
  },
 {
    Header: 'City',
    accessor: 'city'
  },
  {
    Header: 'Country',
    accessor: 'country'
  },
  {
    Header: 'Post code',
    accessor: 'zip'
  },  {
    Header: 'Contact person',
    accessor: 'contact'
  },  {
    Header: 'Opening hours',
    accessor: 'opening_hours'
  }]
const dimensionRows = this.state.shipment.dimensions.map((item)=>
<div className="form-group inline-inputs row">
		<div className="col-1 text-right">
			<button className="btn btn-danger" type="button" onClick={ ()=> this.delDimensionsRow(item.rowId) }>
				<span className="fa fa-minus"></span>
			</button>
		</div>
		<div className="col-5 col-md-1">
			<input className="form-control" name="packing" data-submit="exclude" type="hidden"/>
			<span className="form-control" name="packing">{item.packing}</span>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="length" value={item.length} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Length'/>
				<div className="input-group-append">
					<span className="input-group-text">cm</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="width" value={item.width} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Width'/>
				<div className="input-group-append">
					<span className="input-group-text">cm</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="height" value={item.height} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Height'/>
				<div className="input-group-append">
					<span className="input-group-text">cm</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="number" min="0" name="pieces" value={item.pieces} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Number of pieces'/>
				<div className="input-group-append">
					<span className="input-group-text">pcs</span>
				</div>
			</div>
		</div>
		<div className="col-6 col-md-2">
			<div className="input-group">
				<input className="form-control" type="text" min="0" name="weight" value={item.weight} onChange={ (e)=> this.updateDimensionRow(e,item.rowId) } placeholder='Weight per piece'/>
				<div className="input-group-append">
					<span className="input-group-text">kg</span>
				</div>
			</div>
		</div>
</div>
);  
var previous_comments = this.state.shipment.comments.map((item)=>{
	var data = JSON.parse(item);
	data.date = moment(data.date).format("DD.MM.YYYY");
	return <li className="list-group-item">{data.date} : { data.text }</li>
});
if (this.state.shipment.comments.length===0) {
	previous_comments = <li className="list-group-item">No comments..</li>
}
if(this.state.userLoged===false)return ( <Login onLoginSuccess={this.loginSuccess} value={ this.state.userSignout }/> );
if(this.state.userLoged===true)return (
      <div className="App">
<nav className="navbar navbar-expand-lg navbar-dark bg-dark">
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation" onClick={this.showMenu}>
    <span className="navbar-toggler-icon"></span>
  </button>
  <a className="navbar-brand" href="#">Cargo Management Demo</a>

  <div className={"navbar-collapse "+ this.state.menu_collapse } aria-expanded="true">
    <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
      <li className="nav-item">
        <a className="nav-link" href="#" onClick={ (e)=>this.buchDva(e) }><span className="fa fa-list"> Shipments</span></a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="#" onClick={ ()=>this.buch("settings") }><span className="fa fa-gear"> Settings</span></a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="#" onClick={ this.signout }><span className="fa fa-sign-out"></span> Signout : { this.state.user.name } ({ this.state.user.role })</a>
      </li>
    </ul>
  </div>
</nav>
		<div className="container-fluid mt-2">
      	<div className="row">
   	   	<div id="main_container" className = { this.state.mainContainer }>
   	   		
   	   		<div id="filters" className="row">
   	   		{this.state.user.canCreateRecord === true && (
	  		   			<div className="col-12 new-record-wrap">
	  		   				<button type="button" className="btn btn-success" onClick={()=>this.buch("new") }>Create new record</button>
	  		   			</div>		
	  		   			)}
   	   			<form className="form-inline" onSubmit={()=>{}}>
	   	   			<div className="col-12 col-lg-6">
	   	   				<div className="form-group">
	   	   					<div className="control-label col-12 col-md-3">BOL Number</div>
	   	   					<div className="col-md-9">
	   	   						<input type="text" className="form-control" name="po_num" value={ this.state.searchForm.po_num } onChange = { (e)=> this.searchFormHandleChange(e) }></input>
	   	   					</div>
	   	   				</div>
	   	   				<div className="form-group">
	   	   					<div className="control-label col-12 col-md-3">Asset Number</div>
	   	   					<div className="col-md-9">
	   	   						<input type="text" className="form-control" name="nl_ref" value={ this.state.searchForm.nl_ref } onChange = { (e)=> this.searchFormHandleChange(e) }></input>
	   	   					</div>
	   	   				</div>
	   	   				<div className="form-group">
	   	   					<div className="control-label col-12 col-md-3">MW Reference</div>
	   	   					<div className="col-md-9">
	   	   						<input type="text" className="form-control" name="cts_ref" value={ this.state.searchForm.cts_ref } onChange = { (e)=> this.searchFormHandleChange(e) }></input>
	   	   					</div>
	   	   				</div>
	   	   				<div className="form-group">
	   	   					<div className="control-label col-12 col-md-3">Supplier Name</div>
	   	   					<div className="col-md-9">
	   	   						<input type="text" className="form-control" name="supplier_name" value={ this.state.searchForm.supplier_name } onChange = { (e)=> this.searchFormHandleChange(e) }></input>
	   	   					</div>
	   	   				</div>
	   	   				<div className="form-group">
	   	   					<div className="control-label col-12 col-md-3">Consignee name</div>
	   	   					<div className="col-md-9">
	   	   						<input type="text" className="form-control" name="consignee_name" value={ this.state.searchForm.consignee_name } onChange = { (e)=> this.searchFormHandleChange(e) }></input>
	   	   					</div>
	   	   				</div>
	   	   				<div className="form-group">
	   	   					<div className="control-label col-3">Status</div>
	   	   					<div className="col-md-9">
	   	   						<select className="form-control" name="status" value={ this.state.searchForm.status } onChange = { (e)=> this.searchFormHandleChange(e) }>									<option value="">Choose Live Status</option>
									<option value="Booking Received">Booking Received</option>
									<option value="Collected">Collected</option>
									<option value="Arrived">Arrived</option>
									<option value="Loaded on trailer">Loaded on trailer</option>
									<option value="Off loaded">Off loaded</option>
									</select>
	   	   					</div>
	   	   				</div>
							  <div className="form-group">
							   <div className="control-label col-9 col-md-3">Include Off loaded</div>
							   <div className="col-2 col-md-3">
							   <div className="toggle-switch toggle-switch-primary">
								<label>
							    <input type="checkbox" className="form-check-input" name="include_off" checked={this.state.searchForm.include_off} onChange = { (e)=> this.searchFormHandleChange(e) } />
									<div className="toggle-switch-inner"></div>
									<div className="toggle-switch-switch"><i className="fa fa-check"></i></div>
									</label>
							   </div>
							   </div>
							  </div>
	   	   		</div>
  		   			<div className="col-12 col-lg-6">
  		   				<div className="col-12">
   	   				<div className="form-group row">
   	   					<div className="control-label col-2">Created</div>
   	   					<div className="col-5">
									<DatePicker className="form-control"
										selected = { this.state.searchForm.created_from }
									    onChange={ (val) => this.searchFormHandleChange({ target : { name : "created_from", value : val } }) }
									    dateFormat = "DD.MM.YYYY"
									    utcOffset="0"
										 placeholderText="From"
									/> 
   	   					</div>
   	   					<div className="col-5">
									<DatePicker className="form-control"
										selected = { this.state.searchForm.created_to }
									    onChange={ (val) => this.searchFormHandleChange({ target : { name : "created_to", value : val } }) }
									    dateFormat = "DD.MM.YYYY"
									    utcOffset="0"
									    placeholderText="To"
									/> 
   	   					</div>
   	   				</div>
   	   				<div className="form-group row">
   	   					<div className="control-label col-2">Actual pick up</div>
   	   					<div className="col-5 ">
									<DatePicker className="form-control"
										selected = { this.state.searchForm.actual_pickup_from }
									    onChange={ (val) => this.searchFormHandleChange({ target : { name : "actual_pickup_from", value : val } }) }
									    dateFormat = "DD.MM.YYYY"
									    utcOffset="0"
									    placeholderText="From"
									/> 
   	   					</div>
   	   					<div className="col-5">
									<DatePicker className="form-control"
										selected = { this.state.searchForm.actual_pickup_to }
									    onChange={ (val) => this.searchFormHandleChange({ target : { name : "actual_pickup_to", value : val } }) }
									    dateFormat = "DD.MM.YYYY"
									    utcOffset="0"
									    placeholderText="To"
									/> 
   	   					</div>
   	   				</div>
   	   				<p className="text-muted">* Maximum results is limited to 1000 rows</p>	
   	   				</div>				  		   			
  		   			</div>
  		   			<div className="form-group col-12 mt-1">
  		   				<div className="btn-group col-12" id="searchFormButtons">
	  		   			<button type="button" className="btn btn-primary col-sm-3" onClick={this.performSearch }><i class="fa fa-search"></i> Search</button>
	  		   			<button type="button" className="btn btn-secondary" onClick={this.resetSearch }><i class="fa fa-eraser"></i><span className="d-none d-sm-inline-block">Reset filters</span></button>
			            <ExcelFile filename="Export" element={<button type="button" className="btn btn-default"><i class="fa fa-download"></i><span className="d-none d-sm-inline-block">Download Excel</span></button>}>
			                <ExcelSheet data={this.state.tableData} name="Shipments" >
			                    <ExcelColumn label="BOL Number" value="po_num"/>
			   
										<ExcelColumn label="Asset Number" value="nl_ref"/>
	
			                    <ExcelColumn label="Supplier" value="supplier_name"/>
			                    <ExcelColumn label="Consignee" value="consignee_name"/>
			                    <ExcelColumn label="City" value="delivery_city"/>
			                    <ExcelColumn label="Country" value="delivery_country"/>
			                    <ExcelColumn label="Pieces" value="pieces"/>
			                    <ExcelColumn label="Goods description" value="goods_description"/>
			                    <ExcelColumn label="Weight" value="total_weight"/>
			                    <ExcelColumn label="ETD" value={ (col) => { return col.est_pickup===null ? "": moment(col.est_pickup).format("DD.MM.YYYY"); } }/>
			                    <ExcelColumn label="ETA" value={ (col) => { return col.eta===null ? "": moment(col.eta).format("DD.MM.YYYY"); } }/>
			                    <ExcelColumn label="Created" value={ (col) => { return moment(col.created).format("DD.MM.YYYY"); } }/>
			                    <ExcelColumn label="Status" value={ (col)=> {  
			                    	 	return col.status==="Collected" ? col.status + ' - ' + moment(col.actual_pickup).format("DD.MM.YYYY") : (
												col.status==="Booking Received" ? col.status + ' - ' + moment(col.booking_date).format("DD.MM.YYYY") : (
													col.status==="Arrived" ? col.status + ' - ' + moment(col.actual_arrival).format("DD.MM.YYYY") : (
														col.status==="Loaded on trailer" ? col.status + ' - ' + moment(col.loaded_date).format("DD.MM.YYYY") : (
															col.status==="Off loaded" ? col.status + ' - ' + moment(col.off_loaded).format("DD.MM.YYYY") : null
														)	 	
												 	)	 	
										 		)	 	
										 	)
								}
	 	 } />
			                    <ExcelColumn label="Dimensions" value={ (col)=> {  
			                    		var e = JSON.parse(col.dimensions)
			                    	 	var r = []
			                    	 	e.forEach((s)=> { r.push(s.pieces +" * "+s.packing+" : "+s.length+"x"+s.width+"x"+s.height+" - "+s.weight+"kg") } );
			                    	 	return r.join(",");
	 	 }} />
			                </ExcelSheet>
			            </ExcelFile>
	  		   			</div>
  		   			</div>
  		   		</form>
   	   		</div>
				  <ReactTable
				  	 className="-highlight"
				    data={this.state.tableData}
				    columns={columns}
				  />   	   	
   	   	</div>
   	   	<div id="settings_container" className = { this.state.settingsContainer }>
   	   		<h3><i className="fa fa-gear"/> Settings </h3>
   	   		<form onSubmit={ this.saveSettings }>
   	   			{ this.state.user.role==="admin" && this.state.user.canCreateRecord===true && (
	   				<div className="form-group">
	   					<div className="control-label col-3">Email addresses for notices</div>
	   					<ul className="col-9">	
	   						{ Object.keys(this.emailsAddr).map((e)=> <div> { e } <textarea name={e} className="form-control" defaultValue={this.emailsAddr[e]} /></div> ) }   					
	   					</ul>	
	   					<button className="btn btn-primary" type="submit">Save changes</button>		
	   				</div>   
	   				)}
   	   		</form>
   	   	</div>
	      	<div id="detail_container" className = { this.state.detailContainer }>
					<div className="col-12">    	
	 	 		    	<button className="btn btn-primary" type="button" onClick={this.buchDva}><i className="fa fa-undo"/> Back</button>
	 	 		    	<button className={"btn btn-danger pull-right "+(this.state.isNewRecord ? 'd-none' : '')} type="button" onClick={()=>this.deleteRecord(this.state.shipment.recnum)}><i className="fa fa-trash"/> Delete record</button>
	 	 		    </div>
	 	 	
	      		<form className="" onsubmit="return false">
	   				<div className="form-group ">
	   					<div className="control-label col-3" >Region</div>
	   					<div className="col-12 col-md-6 col-lg-3">
								<select className="form-control" name="region" value={ this.state.shipment.region } onChange = { (e)=> this.shipmentHandleChange(e) }>
									<option value="">Choose region</option>
									<option value="EU Collection">EU Collection</option>
									<option value="Non EU Collection">Non EU Collection</option>
									<option value="Domestic Collection">Domestic Collection</option>
								</select>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">BOL Number</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.po_num } name="po_num" onChange= { (e)=> this.shipmentHandleChange(e) }></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-3">Asset Number</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.nl_ref } name="nl_ref" onChange= { (e)=> this.shipmentHandleChange(e) } ></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-3">MW Reference</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.cts_ref } name="cts_ref" onChange= { (e)=> this.shipmentHandleChange(e) } ></input>
	   					</div>
	   				</div>
  							{ this.state.isEditRecord===true  && (	
  								this.state.user.role==="admin" && (
	   				<div className="form-group">
	   					<div className="control-label col-3">Soot Reference</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" readonly="readonly" value={ "MSRCM"+this.state.shipment.recnum } name="cts_ref" onChange= { (e)=> { return false } }></input>
	   					</div>
	   				</div>
	   				))}
						<div className="form-group">
							<label className="control-label col-3">Packing</label>
							<div className=" col-12 row">
								<div className="col-10 col-md-6 col-lg-3">
									<select className="form-control" name="packing" onChange={ (e)=> this.setState({ shipment_selected_packing : e.target.value }) }>
										<option value="Pallet">Pallet</option>
										<option value="Box">Box</option>
										<option value="CNT">CNT</option>
										<option value="Case">Case</option>
										<option value="Bag">Bag</option>
										<option value="Sack">Sack</option>
										<option value="trunk">Trunk</option>												
										<option value="Other">Other</option>
									</select>
								</div>
								<div className="col-2">
									<button type="button" className="btn btn-primary" onClick={ this.addDimensionsRow }>
										<span className="fa fa-plus"></span>
									</button>
								</div>
							</div>
						</div>
							{ dimensionRows }
	   				<div className="form-group">
	   					<div className="control-label col-6 col-md-3">Total Weight</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.total_weight } readOnly></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-6 col-md-3">Goods description</div>
	   					<div className="col-12 col-md-9">
	   						<textarea type="text" className="form-control" name="goods_description" value={ this.state.shipment.goods_description } onChange = { (e)=> this.shipmentHandleChange(e)}></textarea>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-3">Pieces</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<input type="text" className="form-control" value={ this.state.shipment.pieces } readOnly></input>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">DG / Non DG</div>
	   					<div className="col-12 col-md-6 col-lg-3">
	   						<select className="form-control" name="danger_goods" value={ this.state.shipment.danger_goods } onChange = { (e)=> this.shipmentHandleChange(e) }>
	   							<option value="">Please select</option>
	   							<option value="dg">DG</option>
	   							<option value="nondg">Non DG</option>
	   						</select>
	   					</div>
	   				</div>
	   				<div className="row col-12">
		   				<div className="form-group col-12 col-md-4 col-lg-3">
		   					<div className="control-label">Booking date</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.booking_date }
									onChange= { (val) => this.shipmentHandleChange({ target : { name : "booking_date", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				<div className="form-group col-12 col-md-4 col-lg-3">
		   					<div className="control-label">Ready date</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.ready_date }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "ready_date", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								    utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				<div className={"form-group col-12 col-md-4 col-lg-3 " + (this.state.isNewRecord ? 'd-none' : '') } >
		   					<div className="control-label">Est pick up date</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.est_pickup }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "est_pickup", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				<div className={"form-group col-12 col-md-4 col-lg-3 " + (this.state.isNewRecord ? 'd-none' : '') }>
		   					<div className="control-label">Actual pick up date</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.actual_pickup }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "actual_pickup", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				<div className={"form-group col-12 col-md-4 col-lg-3 " + (this.state.isNewRecord ? 'd-none' : '') }>
		   					<div className="control-label">ETA</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.eta }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "eta", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				<div className={"form-group col-12 col-md-4 col-lg-3 " + (this.state.isNewRecord ? 'd-none' : '') }>
		   					<div className="control-label">Actual arrival</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.actual_arrival }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "actual_arrival", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				<div className={"form-group col-12 col-md-4 col-lg-3 " + (this.state.isNewRecord ? 'd-none' : '') }>
		   					<div className="control-label">Loaded on trailer</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.loaded_date }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "loaded_date", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
							{ this.state.user.role==="admin" && this.state.user.canCreateRecord===true && this.state.isNewRecord===false && (
							<div className="form-group col-12 col-md-4 col-lg-3 ">
		   					<div className="control-label">Off loaded</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.off_loaded }
								    onChange= { (val) => this.shipmentHandleChange({ target : { name : "off_loaded", value : val } }) }
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
		   				)}
		   				<div className={"form-group col-12 col-md-4 col-lg-3 " + (this.state.isNewRecord ? 'd-none' : '') }>
		   					<div className="control-label">Record created date</div>
		   					<div className="">
								<DatePicker className="form-control"
									selected = { this.state.shipment.created }
								    disabled
								    dateFormat = "DD.MM.YYYY"
								     utcOffset="0"
								    placeholderText = "Click to select date"
								/> 
		   					</div>
		   				</div>
	   				</div>
	   				{ this.state.user.role === "admin" ? 
	   				<div className={"form-group " + (this.state.isNewRecord ? 'd-none' : '') }>
	   					<div className="control-label col-12 col-md-3">Add new comment</div>
	   					<div className="col-9">
							<DatePicker className="form-control col-3"
								selected = { this.state.shipment.new_comment_date }
							    onChange= { (val) => this.shipmentHandleChange({ target : { name : "new_comment_date", value : val } }) }
							    dateFormat = "DD.MM.YYYY"
							    placeholderText = "Click to select date"
							/> 
							<textarea className="form-control" name="new_comment_text" value={ this.state.shipment.new_comment_text } onChange={ (e)=>this.shipmentHandleChange(e) }/>
	   					</div>
	   				</div>
	   				:null  }
	   				<div className={"form-group " + (this.state.isNewRecord ? 'd-none' : '') }>
	   					<div className="control-label col-12 col-lg-3">Previous comments</div>
	   					<div className="col-12 col-lg-9">
	   						<ul className="list-group">
		   						{ previous_comments }
		   					</ul>
	   					</div>
	   				</div>
	   				<div className="col-12 col-lg-9 mt-1">
	   					<div className="card">
		   					<h5 className="card-header">
		   					Pickup
		   					</h5>
		   					<div className="card-body">
				   				<div className="form-group">
				   					<div className="control-label col-3" id="supplier">Supplier</div>
				   					<div className="col-12">
				   						<div className="row">
				   						<div className="col-8 col-lg-10">
				   						<input type="text" className="form-control" name="supplier_name" value={ this.state.shipment.supplier_name } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   					<div className="col-4 col-lg-2 btn-group">
				   						<button className="btn btn-primary" type="button" name="supplier" onClick={ ()=> this.openAddressBook("supplier") } ><i className="fa fa-address-book"  /> <span className="d-none d-sm-inline-block">Open</span></button>
				   						<button className="btn btn-success" type="button" name="supplier" onClick={ ()=>this.addToAddressBook("supplier") }><i className="fa fa-plus" /> <span className="d-none d-sm-inline-block">Add</span></button>
				   					</div>
				   					</div>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Pickup Address</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Street" name="pickup_street" value={ this.state.shipment.pickup_street } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="City" name="pickup_city" value={ this.state.shipment.pickup_city } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Country" maxLength="100" name="pickup_country" value={ this.state.shipment.pickup_country } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Post code" maxLength="15" name="pickup_zip" value={ this.state.shipment.pickup_zip } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Contact Person</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Name, tel, email" name="pickup_contact" value={ this.state.shipment.pickup_contact } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Opening hours</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="" name="pickup_opening_hours" value={ this.state.shipment.pickup_opening_hours } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
			   				</div>
	   					</div>	   				
	   				</div>
	   				<div className="col-12 col-lg-9 mt-1 mb-1">
	   					<div className="card">
		   					<h5 className="card-header">
		   					Delivery
		   					</h5>
		   					<div className="card-body">
				   				<div className="form-group">
				   					<div className="control-label col-3" id="consignee">Consignee</div>
				   					<div className="col-12">
				   						<div className="row">
				   						<div className="col-8 col-lg-10">
				   						<input type="text" className="form-control" name="consignee_name" value={ this.state.shipment.consignee_name } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   						</div>
				   						<div className="col-4 col-lg-2 btn-group">
				   						<button className="btn btn-primary" type="button" name="consignee" onClick={ ()=> this.openAddressBook("consignee") }><i className="fa fa-address-book" /> <span className="d-none d-sm-inline-block">Open</span></button>
				   						<button className="btn btn-success" type="button"  name="consignee" onClick={ ()=>this.addToAddressBook("consignee") }><i className="fa fa-plus" /> <span className="d-none d-sm-inline-block">Add</span></button>
				   						</div>
				   						</div>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Ship to Address</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Street" name="delivery_street" value={ this.state.shipment.delivery_street } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="City" name="delivery_city" value={ this.state.shipment.delivery_city } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Country" maxLength="100" name="delivery_country" value={ this.state.shipment.delivery_country } onChange = { (e)=> this.shipmentHandleChange(e) }/>
											<input type="text" className="form-control" placeholder="Post code" maxLength="15" name="delivery_zip" value={ this.state.shipment.delivery_zip } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Contact person</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="Name, tel, email" name="delivery_contact" value={ this.state.shipment.delivery_contact } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
				   				<div className="form-group">
				   					<div className="control-label col-3">Opening hours</div>
				   					<div className="col-12 col-lg-9">
											<input type="text" className="form-control" placeholder="" name="delivery_opening_hours" value={ this.state.shipment.delivery_opening_hours } onChange = { (e)=> this.shipmentHandleChange(e) }/>
				   					</div>
				   				</div>
			   				</div>
		   				</div>
		   			</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">Special instructions</div>
	   					<div className="col-12 col-lg-9">
								<textarea className="form-control" name="special_instructions" value={ this.state.shipment.special_instructions } onChange = { (e)=> this.shipmentHandleChange(e) }/>
	   					</div>
	   				</div>
	   				<div className="form-group">
	   					<div className="control-label col-12 col-md-3">Send email alerts to</div>
	   					<div className="col-12 col-lg-9">
	   						<input type="text" placeholder="email addresses separated by commas" className="form-control" value={ this.state.shipment.notice_emails } name="notice_emails" onChange= { (e)=> this.shipmentHandleChange(e) }></input>
	   					</div>
	   				</div>
	   				<div className={"form-group " + (this.state.isNewRecord ? 'd-none' : '') }>
	   					<div className="control-label col-3" >Status</div>
	   					<div className="col-12 col-lg-3">
								<span className="form-control">{ this.state.shipment.status }</span>
	   					</div>
	   				</div>
	   				<div className="form-group col-12 " >
	   					<div className="control-label">Attachments</div>
	   					<div className="col-12">
	   						<div className="row fileslist">
	   						{ this.state.shipment.filesnames.map((file)=>
									<div className="list-group-item col-12 col-sm-6 col-md-3"><i className="fa fa-trash" title="Delete attachment" onClick={()=>this.deleteAttachment(file[0])} /><button type="button" className="btn btn-secondary" onClick={ ()=> this.downloadFile(file[0]) }><span className="fa fa-download"></span></button>  { file[1] }</div>	   			
									)			
	   						 }
	   						 </div>
          <Dropzone onDrop={this.handleFileUpload.bind(this)} className="dropzone mt-1"  activeClassName="dropzoneActive">
            <p>Drop new files here, or click to select files to upload.</p>
          </Dropzone>	  
          					{this.state.shipment.files.length > 0 ? <p className="mt-2">Files to upload</p> : ''} 						 
	   						 <ul className="fileUploadList">{ this.state.shipment.files.map(f => <li key={f.name} className="list-group-item"><i className="fa fa-trash" title="Delete attachment" onClick={()=>this.deleteAttachment(f.name,true)} /> {f.name}</li> )}</ul>						
	   					</div>
	   				</div>	   			
	   				<div className="form-group">
	   					<div className="btn-group col-12 col-lg-6">
								{ this.state.isEditRecord===true  && (
									<button type="button" className="btn btn-success col-6 col-md-3" onClick={ this.updateRecord }>Update</button>
								)}
								{ this.state.isEditRecord===true  && (
									<button type="button" className="btn btn-secondary col-6 col-md-3" onClick= { ()=>this.printShipment("p") } >Print</button>
								)}
								{ this.state.isEditRecord===true  && (
									<button type="button" className="btn btn-secondary col-6 col-md-3" onClick= { ()=>this.printShipment("c") } >Collection/Delivery</button>
									)}
									{ this.state.isEditRecord===true && this.state.user.canCreateRecord === "t" && (
  										<button type="button" className="btn btn-success col-6 col-md-3" onClick={()=>this.buch("new") }>Create another record </button>
  								 	)}
  								
  							{ this.state.isNewRecord===true  && (	
  								this.state.user.canCreateRecord && (
  								<button type="button" className="btn btn-success col-6 col-md-3" onClick={ this.createRecord }>Create new record</button>
  								)
  	 						)}
								<button type="button" className="btn btn-primary col-6 col-md-3" onClick={this.buchDva}><i className="fa fa-undo"/> Back</button>
								
							</div>
	   				</div> 
					</form>  
				</div>
				<div id="addressbook" className={ this.state.AddressbookContainer }>
				<h3><i className="fa fa-address-book"/> Address Book </h3>
					<button type="button" className="btn btn-primary" onClick={ ()=>(this.setState({ AddressbookContainer : "d-none", detailContainer : "col-12" }))  }><i className="fa fa-undo"/> Back</button>
				  <ReactTable
				  	 className="-highlight"
				    data={this.state.addressBookData}
				    columns={addressBookColumns}
				  />  
				</div>
      	</div>
      	</div>
			<NotificationContainer/>
			
			<div id="end"></div>
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js